export enum EButtonType {
  Primary = 'primary',
  Secondary = 'secondary',
  Transparent = 'transparent',
  Outline = 'outline',
  SignInWith = 'sign-in-with',
  Blue = 'blue',
  PrimaryLoadText = 'primary-load-text',
}
